var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusculoEsqueleticoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.774,
    height: 18.775,
    viewBox: "0 0 18.774 18.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12780",
    "data-name": "Group 12780",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7320",
    "data-name": "Path 7320",
    d: "M4969.464,849.338a.656.656,0,0,1-.386-.7c.018-.485,0-.972.007-1.458a.174.174,0,0,0-.126-.192,3.114,3.114,0,1,1,2.505-5.7.428.428,0,0,0,.443,0,3.114,3.114,0,1,1,2.505,5.7.175.175,0,0,0-.125.192c.005.486-.01.972.007,1.458a.656.656,0,0,1-.386.7Zm3.107-7.2c.038.057.064.1.094.141a3.111,3.111,0,0,1,.58,1.715.525.525,0,1,1-1.04.043,2.082,2.082,0,1,0-2.694,2.039c.54.159.613.256.613.819v1.389h3.124V848.1c0-.457,0-.914,0-1.371a.542.542,0,0,1,.438-.6c.056-.018.11-.036.166-.051a1.969,1.969,0,0,0,1.008-.673,2.071,2.071,0,0,0-2.289-3.268Z",
    transform: "translate(-4962.8 -831.563)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7321",
    "data-name": "Path 7321",
    d: "M5221.654,817.48a.654.654,0,0,1-.7.386c-.449-.018-.9,0-1.351,0a.524.524,0,1,1,0-1.041c.45,0,.9.013,1.351,0a.654.654,0,0,1,.7.386Z",
    transform: "translate(-5203.88 -808.453)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7322",
    "data-name": "Path 7322",
    d: "M4971.811,624.132h1.978a.536.536,0,0,1,.61.6c0,.509,0,1.018,0,1.527a.2.2,0,0,0,.15.228,3.118,3.118,0,0,1-.666,5.96,2.97,2.97,0,0,1-1.917-.3.327.327,0,0,0-.334,0,3.11,3.11,0,0,1-4.506-2.988,3.017,3.017,0,0,1,1.9-2.663.229.229,0,0,0,.17-.249c-.01-.509,0-1.018,0-1.527a.53.53,0,0,1,.589-.591C4970.458,624.131,4971.135,624.132,4971.811,624.132Zm-.9,7.191c-.034-.051-.06-.09-.086-.127a3.079,3.079,0,0,1-.585-1.766.522.522,0,1,1,1.04-.026,2.069,2.069,0,0,0,2.449,2.012,1.958,1.958,0,0,0,1.605-1.392,2,2,0,0,0-.441-2.049,2.035,2.035,0,0,0-1.023-.617.568.568,0,0,1-.507-.671q0-.521,0-1.041v-.459h-3.125v1.453c0,.47-.094.6-.545.73a2.07,2.07,0,1,0,1.218,3.953Z",
    transform: "translate(-4962.909 -624.132)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7323",
    "data-name": "Path 7323",
    d: "M4871.523,817.943c-.254,0-.509,0-.764,0a.52.52,0,1,1,0-1.039q.773-.006,1.544,0a.52.52,0,1,1,0,1.039C4872.044,817.946,4871.784,817.943,4871.523,817.943Z",
    transform: "translate(-4870.215 -808.535)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7324",
    "data-name": "Path 7324",
    d: "M4896.954,746.331a.549.549,0,0,1-.3.512.451.451,0,0,1-.535-.056c-.39-.37-.772-.748-1.14-1.14a.512.512,0,0,1,.717-.719c.393.367.769.751,1.14,1.14A.758.758,0,0,1,4896.954,746.331Z",
    transform: "translate(-4893.792 -739.574)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    d: "M5209.068,745.484a1.286,1.286,0,0,1-.18.309c-.325.344-.663.677-1,1.008a.519.519,0,1,1-.734-.733q.5-.515,1.018-1.018a.493.493,0,0,1,.59-.108A.557.557,0,0,1,5209.068,745.484Z",
    transform: "translate(-5192.366 -739.647)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    d: "M4895.416,866.886a.546.546,0,0,1-.509-.294.448.448,0,0,1,.05-.536c.373-.394.755-.781,1.152-1.151a.511.511,0,0,1,.713.719c-.371.4-.76.776-1.152,1.151A.712.712,0,0,1,4895.416,866.886Z",
    transform: "translate(-4893.773 -854.349)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    d: "M5208.471,867.021a1.178,1.178,0,0,1-.306-.166c-.353-.333-.694-.679-1.032-1.027a.519.519,0,1,1,.739-.727c.344.335.682.675,1.018,1.018a.5.5,0,0,1,.113.589A.558.558,0,0,1,5208.471,867.021Z",
    transform: "translate(-5192.355 -854.481)",
    fill: "#394f65",
    stroke: "#394e64",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusculoEsqueleticoImage);
export default __webpack_public_path__ + "static/media/musculo_esqueletico_image.837e8ca813ae9c62d8b048061f1035d7.svg";
export { ForwardRef as ReactComponent };